import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '@app/api/shared';
import {
  TimezonesEndpoints as Endpoints,
  type ConvertTimezonesToLinuxRequest,
  type ConvertTimezonesToLinuxResponse,
  type GetCrmTimezonesRequest,
  type GetCrmTimezonesResponse,
  type GetTimezonesRequest,
  type GetTimezonesResponse,
} from '@app/api/Timezones/types';
import { TIMEZONE_CHUNK } from '@app/constants';

export const timezonesApi = createApi({
  reducerPath: 'timezonesApi',
  baseQuery: createApiBaseQuery(TIMEZONE_CHUNK),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.GetTimezones]: query<GetTimezonesResponse, GetTimezonesRequest>({
      query: (params) => ({
        url: Endpoints.GetTimezones,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetCrmTimezones]: query<
      GetCrmTimezonesResponse,
      GetCrmTimezonesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetCrmTimezones,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.ConvertTimezonesToLinux]: mutation<
      ConvertTimezonesToLinuxResponse,
      ConvertTimezonesToLinuxRequest
    >({
      query: (params) => ({
        url: Endpoints.ConvertTimezonesToLinux,
        method: Methods.PUT,
        params,
      }),
    }),
  }),
});

export const {
  useGetCrmTimezonesQuery,
  useLazyGetCrmTimezonesQuery,
  useGetTimezonesQuery,
  useLazyGetTimezonesQuery,
  useConvertTimezonesToLinuxMutation,
} = timezonesApi;
